// LICENSE : MIT
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var DispatcherPayloadMeta_1 = require("./DispatcherPayloadMeta");
var assert_1 = require("./util/assert");
var Events_1 = require("./Events");
/**
 * Dispatcher is the **central** event bus system.
 *
 * `Dispatcher` class  have these method.
 *
 * - `onDispatch(function(payload){ });`
 * - `dispatch(payload);`
 *
 * Dispatcher pass `payload` object and `meta` object.
 *
 * ## Payload
 *
 * `payload` object must have `type` property.
 * Following object is a minimal `payload` object.
 *
 * ```json
 * {
 *     "type": "type"
 * }
 * ```
 *
 * Also, You can put any property to payload object.
 *
 * ```json
 * {
 *     "type": "show",
 *     "value": "value"
 * }
 * ```
 *
 * ## PayloadMeta
 *
 * `meta` object represent meta information for payload
 * PayloadMeta is created automatically when that payload is dispatched.
 *
 * ### FAQ
 *
 * Q. Why Almin use `payload` object instead `emit(key, ...args)`?
 *
 * A. It is for optimization and limitation.
 * If apply emit style, we should cast `...args` for passing other dispatcher at every time.
 * So, Almin use `payload` object instead of it without casting.
 */
var Dispatcher = /** @class */ (function (_super) {
    __extends(Dispatcher, _super);
    function Dispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * if `v` is instance of Dispatcher, return true
     */
    Dispatcher.isDispatcher = function (v) {
        if (v instanceof Dispatcher) {
            return true;
        }
        else if (typeof v === "object" && typeof v.onDispatch === "function" && typeof v.dispatch === "function") {
            return true;
        }
        return false;
    };
    /**
     * Add `handler`(subscriber) to Dispatcher and return unsubscribe function
     *
     * ### Example
     *
     * ```js
     * const dispatcher = new Dispatcher();
     * const unsubscribe = dispatcher.onDispatch((payload, meta) => {});
     * unsubscribe(); // release handler
     * ```
     */
    Dispatcher.prototype.onDispatch = function (handler) {
        return this.addEventListener(function (event) { return handler(event.payload, event.meta); });
    };
    /**
     * Dispatch `payload` to subscribers.
     */
    Dispatcher.prototype.dispatch = function (payload, meta) {
        if (process.env.NODE_ENV !== "production") {
            assert_1.assertOK(payload !== undefined && payload !== null, "payload should not null or undefined");
            assert_1.assertOK(typeof payload.type !== "undefined", "payload's `type` should be required");
            if (meta !== undefined) {
                assert_1.assertOK(meta instanceof DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl, "`meta` object is internal arguments.");
            }
        }
        // `meta` must be generated by system
        if (meta instanceof DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl) {
            this.emit({
                payload: payload,
                meta: meta
            });
        }
        else {
            // the `payload` object generated by user
            var dispatchOnlyMeta = new DispatcherPayloadMeta_1.DispatcherPayloadMetaImpl({
                isTrusted: false
            });
            this.emit({
                payload: payload,
                meta: dispatchOnlyMeta
            });
        }
    };
    /**
     * Delegate payload object to other dispatcher.
     *
     * ### Example
     *
     * ```js
     * const a = new Dispatcher();
     * const b = new Dispatcher();
     * // Delegate `a` to `b`
     * a.pipe(b);
     * // dispatch and `b` can receive it.
     * a.dispatch({ type : "a" });
     * ```
     */
    Dispatcher.prototype.pipe = function (toDispatcher) {
        var fromName = this.constructor.name;
        var toName = toDispatcher.constructor.name;
        var displayName = "delegate-payload:" + fromName + "-to-" + toName;
        var delegatePayload = function delegatePayload(payload, meta) {
            delegatePayload.displayName = displayName;
            toDispatcher.dispatch(payload, meta);
        };
        return this.onDispatch(delegatePayload);
    };
    return Dispatcher;
}(Events_1.Events));
exports.Dispatcher = Dispatcher;
//# sourceMappingURL=Dispatcher.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/Dispatcher.js
// module id = 22
// module chunks = 0